import { useCallback } from 'react'

import { getPlacesByGeocode } from '../services/googleMapsServices'
import {
  filterByTypes,
  formatGoogleAutoCompleteResponse
} from '../utils/googleMapsUtils'

export function useCoords() {
  const getPosition = useCallback(
    async (latitude: number, longitude: number) => {
      const { isSuccess, data } = await getPlacesByGeocode({
        coordinates: {
          latitude,
          longitude
        }
      })

      if (!isSuccess || !data?.length) {
        return Promise.reject(new Error('No places found'))
      }

      const filter = filterByTypes({
        places: data || []
      })

      const place = filter?.length ? filter[0] : undefined

      if (!place?.id) {
        return Promise.reject(new Error('No places found'))
      }

      const formatted = formatGoogleAutoCompleteResponse({
        place: {
          ...place,
          location: {
            latitude,
            longitude
          }
        }
      })

      return formatted
    },
    []
  )

  return {
    getPosition
  }
}
